import { Link } from "react-router-dom";
import styled from "styled-components";

export const StoreLogo = styled(Link)`
  display: inline-block;
  margin-bottom: 0.5rem;

  img {
    width: 3rem;
    height: 3rem;
    object-fit: contain;
  }
`;